import React from "react";

const FeatureHighlights = () => (
  <section className="py-16 bg-neutral-50 dark:bg-neutral-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="h-12 w-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-orange-500 to-orange-700 grid place-items-center">
            <span className="text-white text-xl">📈</span>
          </div>
          <h3 className="text-lg font-semibold text-neutral-800 dark:text-neutral-100 mb-2">Amortization Schedule</h3>
          <p className="text-sm text-neutral-600 dark:text-neutral-300">Detailed month-by-month breakdown of your loan.</p>
        </div>
        <div className="text-center">
          <div className="h-12 w-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-green-500 to-green-700 grid place-items-center">
            <span className="text-white text-xl">🏦</span>
          </div>
          <h3 className="text-lg font-semibold text-neutral-800 dark:text-neutral-100 mb-2">DTI Calculator</h3>
          <p className="text-sm text-neutral-600 dark:text-neutral-300">Check your loan eligibility instantly.</p>
        </div>
        <div className="text-center">
          <div className="h-12 w-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 grid place-items-center">
            <span className="text-white text-xl">⚖️</span>
          </div>
          <h3 className="text-lg font-semibold text-neutral-800 dark:text-neutral-100 mb-2">Flat vs Reducing Rates</h3>
          <p className="text-sm text-neutral-600 dark:text-neutral-300">Compare interest computations with a simple toggle.</p>
        </div>
      </div>
    </div>
  </section>
);

export default FeatureHighlights;
